<template>
	<div class="w-100">
		<div class="importing-beneficiarios">
			
			<div class="importing-beneficiarios-header pt-4">
				<div class="header w-100" v-if="isFinished()">
					<DynamicIcon icon="check" :classString="'container-modal-title-icon'"/>
					<p class="title my-4">Importação concluída</p>
				</div>
				<div class="header" v-else-if="isError()">
					<div class="has-errors">
						<DynamicIcon icon="exclamation" :classString="'container-modal-title-icon'"/>
						<p class="title">Importacao com erro</p>
						<p class="sub-title">Houve um erro inesperado na leitura do arquivo!</p>
					</div>
				</div>
				<div  class="header" v-else-if="isValidating()">
					<DynamicIcon icon="clock" :classString="'container-modal-title-icon'"/>
					<p class="title my-4">Validação em andamento</p>
					<p class="sub-title">Estamos validando sua base. Este processo pode levar algum tempo, mas não se preocupe. Você receberá um e-mail quando a validação for concluída.</p>
				</div>
				<div  class="header" v-else-if="isQueueFile()">
					<DynamicIcon icon="clock" :classString="'container-modal-title-icon'"/>
					<p class="title my-4">Upload de arquivo</p>
					<p class="sub-title">Estamos realizando o upload da sua base para o servidor. Este processo pode levar algum tempo, aguarde até a mudança de status para validação em andamento.</p>
				</div>
				<div class="header" v-else>
					<DynamicIcon icon="clock" :classString="'container-modal-title-icon'"/>
					<p class="title my-4">Importação em andamento</p>
					<div class="sub-title">
						<p>Estamos importando sua base. Este processo pode levar algum tempo, mas não se preocupe. Você receberá um e-mail quando a importação for concluída.</p>
						<br/>
						<p>Para realizar uma nova importação aguarde a conclusão desta ou cancele.</p>
					</div>
				</div>
			</div>

			<LoadingProgress v-if="isLoading" :value="progressValue"/>

			<div class="footer">
				<div class="butons-bar" v-if="isFinished()">
					<b-button pill class="btn-base outline-primary-btn mr-2 optum-bold" @click="navigateToHistoricoBeneficiario(true)">Lista de beneficiários</b-button>
					<b-button pill class="btn-base primary-btn optum-bold" @click="navigateToHistoricoImportacao(true)">Ver histórico</b-button>
				</div>
				<div class="butons-bar" v-else>
					<b-button pill class="btn-base outline-primary-btn mr-2 optum-bold" @click="$bvModal.show('cancelar-import-beneficiario')">Cancelar {{isValidating() ? "validação" :"importação"}}</b-button>
				</div>
			</div>
		</div>
	</div>	
</template>

<script>
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import LoadingProgress from "@/components/commons/LoadingProgress.vue";
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
	name: "ImportacaoEmAndamento",
	props: {
		importacao: Object,
		finishImportacao: Boolean
	},
	components: {
		LoadingProgress,
		DynamicIcon,
	},
	data() {
		return {
			estatisticas: null,
			isLoading: false,
			intervalId: null,
			progressValue: 0,
			status: null
		}
	},
    methods: {
		terminadoComSucesso() {
			return this.status == 'FINISHED' && this.estatisticas && 
			!this.estatisticas.PRE_IMPORTING && !this.estatisticas.INVALID
		},
		isValidating() {
			return this.status == 'VALIDATING'
		},
		isQueueFile() {
			return this.status == 'QUEUE_FILE'
		},
		isImporting() {
			return this.status == 'IMPORTING'
		},
		isFinished() {
			return this.status == 'FINISHED' || this.status == 'IMPORTED'
		},
		isError() {
			return this.status == 'QUEUE_FILE_ERROR'
		},
		isWaitingStart() {
			return this.status == 'WAINTING_START'
		},
		isCanceled() {
			return this.status == 'CANCELED'
		},
		loadEstatisticas() {
			return BeneficiarioImportacaoResource.getEstatisticas()
			.then((response) => {

				if (this.importacao.status == 'WAINTING_START') return
				
				if (this.status != this.importacao.status) {
					this.progressValue = 0;
					this.status = this.importacao.status
				}

				this.$emit("updateImportacao", response.importacao)
				this.$set(this, "estatisticas", response.estatisticas)

				if (!(this.isQueueFile() || this.isError() || this.isCanceled(), this.isWaitingStart())) {
					this.isLoading = true

					if (this.isQueueFile() || this.isValidating() || this.isImporting()) {
						let valor = response.progressBar.value || 0

						if(valor > this.progressValue)
							this.progressValue = valor
					}

					if(this.isFinished())
						this.progressValue = 100
				}
				
				if (this.terminadoComSucesso())
					clearInterval(this.intervalId)

			})
		},
		desativarImportacao() {
			BeneficiarioImportacaoResource.desativarImportacao(this.importacao.id, {showLoader: true})
			.then((importacao) => {
				this.$emit("updateImportacao", importacao)
			})
		},
		iniciarNovaImportacao() {
            BeneficiarioImportacaoResource.finalizarImportacao(this.importacao.id, {showLoader: true})
            .then(() => {
                this.$emit("updateImportacao", null)
            })
		},
		navigateToHistoricoBeneficiario(novaImportacao = false)
		{
			if(novaImportacao)
				this.iniciarNovaImportacao()

			this.$router.replace({path: '/master-page/historico-beneficiario'})
		},
		navigateToHistoricoImportacao(novaImportacao = false)
		{
			if(novaImportacao)
				this.iniciarNovaImportacao()

			this.$router.replace({path: '/master-page/historico-importacao'})
		}
    },
	watch: {
		finishImportacao: function(newVal) {
			if(newVal)
				clearInterval(this.intervalId)
		}
	},
	created() {
		this.loadEstatisticas()

		this.intervalId = setInterval(() => { this.loadEstatisticas() }, 1000 * 1);
	},
	beforeDestroy () {
		if (this.intervalId) {
			clearInterval(this.intervalId)
		}
	}
}
</script>

<style scoped>

.importing-beneficiarios {
	width: 70%;
	justify-content: space-between;
	margin-left: auto;
	margin-right: auto;
    color: #707070;
	font-size: 18px;
	text-align: left;
    background-color: #fff;
}

.importing-beneficiarios-header {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 24px;
	gap: 32;
}

.header {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width:774px;
}

.title {
	font-size: 24px !important;
	font-family: optum-sans-bold !important;
	color: #002677;
	line-height :24px;
	font-weight: 700;
	text-align: center;
}

.footer {
	margin-top: 24px;
}

.sub-title {
	font-family: optum-sans !important;
	font-size: 18px !important;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: 0em;
	text-align: center;
	color:#5A5A5A !important;
	margin: 10px 0 10px 0;
}

.container-modal-title-icon {
	height: 80px !important;
}

.butons-bar {
	display: flex;
	justify-content: end;
    margin-bottom: 10px;
}

.butons-bar button {
	font-weight: bold !important;
}

.butons-bar .deativar-importacao {
	background-color: #FF612B;
	margin-left: 5px;
}

.butons-bar .deativar-importacao:hover {
	background-color: #002677;
	margin-left: 5px;
}

.button-bar-down {
	margin: 20px;
	margin-top: 60px;
	text-align: center;
}

.button-bar-down button {
    font-size: 16px !important;
	font-weight: bold;
    padding: 20px 20px 20px 20px;
    padding-bottom: 20px;
	margin-left: 20px;
	margin-right: 20px;
}

.has-errors{
	margin-top: 50px;
    color: #E32315;
    font-weight: bold;
    text-align: center;
}
</style>